var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":("/storage/" + _vm.file),"data-lity":""}},[_c('img',{staticClass:"img-thumbnail",attrs:{"src":_vm.sourcePath,"draggable":"true"},on:{"dragstart":function($event){_vm.$emit('startDrag', $event)},"dragend":function($event){_vm.$emit('endDrag', $event)}}}),_vm._v(" "),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f02456","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/trials/GalleryThumb.vue
// module id = ETlt
// module chunks = 0